<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#E1F5FE"
                  d="M19.003 33.61H8.497l-2.292-9.166h15.09l-2.292 9.167zM18.03 7.167l-.043.044c-.3.278-.686.43-1.098.43-.43 0-.835-.167-1.138-.47-.305-.306-.472-.71-.472-1.14 0-.432.167-.836.47-1.14l.133-.132c1.086-1.023 2.479-1.618 3.967-1.694-.082 1.528-.716 3-1.819 4.102zm-6.025 6.351c-.438 1.06-1.463 1.745-2.611 1.745-.37 0-.732-.074-1.08-.217-2.26-.936-4-2.794-4.828-5.06 1.15-.534 2.41-.82 3.68-.82 1.136 0 2.25.224 3.31.664.699.288 1.243.831 1.53 1.528.288.696.288 1.463 0 2.16z"
                  transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667)"
                />
                <path
                  fill="#13A2E8"
                  fill-rule="nonzero"
                  d="M22.6.317c-3.112-.829-6.568-.031-9.01 2.409v.003c-.931.932-1.38 2.16-1.36 3.381h-.007v1.204c-.192-.104-.371-.223-.576-.309C7.629 5.34 3.223 6.08 0 8.542c.536 4.024 3.129 7.66 7.147 9.327 1.717.71 3.566.524 5.076-.305v3.825h3.055V10.397c1.654.609 3.584.26 4.912-1.068l.001-.002C22.632 6.886 23.428 3.43 22.6.317zm-10.595 13.2c-.438 1.06-1.463 1.745-2.611 1.745-.37 0-.732-.074-1.08-.217-2.26-.936-4-2.794-4.828-5.06 1.15-.534 2.41-.82 3.68-.82 1.136 0 2.25.224 3.31.664.699.288 1.243.831 1.53 1.528.288.696.288 1.463 0 2.16zm6.025-6.351l-.043.044c-.3.278-.686.43-1.098.43-.43 0-.835-.167-1.138-.47-.305-.306-.472-.71-.472-1.14 0-.432.167-.836.47-1.14l.133-.132c1.086-1.023 2.479-1.618 3.967-1.694-.082 1.528-.716 3-1.819 4.102z"
                  transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667)"
                />
                <path fill="#164194" fill-rule="nonzero" d="M0 21.389v3.056h3.056l3.055 12.222H21.39l3.055-12.222H27.5v-3.056H0zM19.003 33.61H8.497l-2.292-9.167h15.09l-2.292 9.167z" transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667)" />
              </g>
              <g>
                <path fill="#FFF" d="M1.667 1.667H10V10H1.667z" transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667) translate(15 28.333)" />
                <path fill="#13A2E8" fill-rule="nonzero" d="M0 0v11.667h11.667V0H0zm10 10H1.667V1.667H10V10z" transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667) translate(15 28.333)" />
                <path
                  fill="#13A2E8"
                  fill-rule="nonzero"
                  d="M8.333 4.958L6.708 4.958 6.708 3.333 4.958 3.333 4.958 4.958 3.333 4.958 3.333 6.708 4.958 6.708 4.958 8.333 6.708 8.333 6.708 6.708 8.333 6.708z"
                  transform="translate(-1011 -325) translate(981 296) translate(30 30) translate(6.667) translate(15 28.333)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>